import { Info } from "lucide-react";
import { getDataFreshnessMessage, isIncompleteCurrentMonth } from "../../utils/dateUtils";

interface DataFreshnessProps {
  monthString: string;
  className?: string;
}

/**
 * Component to display data freshness information
 * Shows when the data was last updated
 */
export function DataFreshness({ monthString, className = "" }: DataFreshnessProps) {
  const message = getDataFreshnessMessage(monthString);
  const isIncomplete = isIncompleteCurrentMonth(monthString);
  
  return (
    <div 
      className={`flex items-center gap-2 text-xs ${
        isIncomplete 
          ? "text-amber-600 dark:text-amber-400" 
          : "text-muted-foreground"
      } ${className}`}
    >
      <Info className="h-3 w-3" />
      <span>{message}</span>
    </div>
  );
}




